import { Skeleton } from "antd"


const CargandoTabla = () => {
    return <div>
        <Skeleton active />
    </div>
}

export default CargandoTabla